/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NftPurchaseTransaction,
    NftPurchaseTransactionFromJSON,
    NftPurchaseTransactionFromJSONTyped,
    NftPurchaseTransactionToJSON,
} from './';

/**
 * 
 * @export
 * @interface NftPurchaseCartItem
 */
export interface NftPurchaseCartItem {
    /**
     * 
     * @type {string}
     * @memberof NftPurchaseCartItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NftPurchaseCartItem
     */
    nftSaleConfig: string;
    /**
     * 
     * @type {number}
     * @memberof NftPurchaseCartItem
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof NftPurchaseCartItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof NftPurchaseCartItem
     */
    subtotal: number;
    /**
     * 
     * @type {Array<NftPurchaseTransaction>}
     * @memberof NftPurchaseCartItem
     */
    transactions?: Array<NftPurchaseTransaction>;
}

export function NftPurchaseCartItemFromJSON(json: any): NftPurchaseCartItem {
    return NftPurchaseCartItemFromJSONTyped(json, false);
}

export function NftPurchaseCartItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftPurchaseCartItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'nftSaleConfig': json['nftSaleConfig'],
        'quantity': json['quantity'],
        'price': json['price'],
        'subtotal': json['subtotal'],
        'transactions': !exists(json, 'transactions') ? undefined : ((json['transactions'] as Array<any>).map(NftPurchaseTransactionFromJSON)),
    };
}

export function NftPurchaseCartItemToJSON(value?: NftPurchaseCartItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'nftSaleConfig': value.nftSaleConfig,
        'quantity': value.quantity,
        'price': value.price,
        'subtotal': value.subtotal,
        'transactions': value.transactions === undefined ? undefined : ((value.transactions as Array<any>).map(NftPurchaseTransactionToJSON)),
    };
}


